/*
 * WW Home Quotes — press-bar marquee driver
 * Version: 1.0.0 - 2026-08-10 12:10 (UTC+8) - Plaud Tayler — DTC-1027: viewport gate for the
 *   mobile logo loop. CSS owns the animation (ww-home-quotes.css); this file only toggles
 *   .is-running via IntersectionObserver so the loop never burns cycles offscreen (animation
 *   rule 1). Reduced-motion never gets the animation (CSS gate), so no JS branch needed here.
 * Idempotent + Section Rendering API-safe: re-scans on shopify:section:load.
 */
(function () {
  if (window.__wwHomeQuotesMarquee) return;
  window.__wwHomeQuotesMarquee = true;

  var io = null;

  function observe() {
    if (!('IntersectionObserver' in window)) {
      // no IO support: just run it (the loop is mobile-only and cheap)
      document.querySelectorAll('[data-whq-marquee]').forEach(function (el) {
        el.classList.add('is-running');
      });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          entry.target.classList.toggle('is-running', entry.isIntersecting);
        });
      }, { rootMargin: '80px 0px' });
    }
    document.querySelectorAll('[data-whq-marquee]').forEach(function (el) {
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
  document.addEventListener('shopify:section:load', observe);
})();
